export default __webpack_public_path__ + "static/ulomakPdf-db0bbc7fb9afd0afd1cf3068f7868cc6.pdf";